import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UserPermissionsDirective, FeatureFlagDirective } from '@bn/auth/directives';
import { LazyLoadDirective } from '@bn/web-ui';
import { ButtonComponent } from '@bn/web-ui/button/button.component';
import { BannerItem, MenuItem } from './models';

@Component({
  selector: 'bn-dashboard-add-menu',
  templateUrl: './add-menu.component.html',
  styleUrls: ['./add-menu.component.scss'],
  imports: [UserPermissionsDirective, FeatureFlagDirective, NgTemplateOutlet, LazyLoadDirective, ButtonComponent, RouterLink],
})
export class AddMenuComponent implements OnInit {
  @Input()
  public menuItems: MenuItem[] = [];

  @Input()
  public defaultBannerItem?: BannerItem;

  public baseItems: MenuItem[] = [];
  public computedItems: MenuItem[] = [];

  public bannerItem?: BannerItem;

  public readonly itemClickedEvent = output<boolean>();

  public ngOnInit(): void {
    this.initItems();
  }

  private initItems() {
    this.baseItems = this.menuItems.filter((item) => item.group === 'delivery');
    this.computedItems = this.menuItems.filter((item) => item.group === 'compute');
    this.bannerItem = this.defaultBannerItem;
  }

  public onHover(item: MenuItem) {
    if (item.bannerItem) {
      this.bannerItem = item.bannerItem;
    } else {
      this.bannerItem = this.defaultBannerItem;
    }
  }
}
